import React from 'react';

interface _GridItemMenuProps {
    onDuplicate: () => void;
    onDelete: () => void;
    onRotate: () => void;
}

const _GridItemMenu: React.FC<_GridItemMenuProps> = ({ onDuplicate, onDelete, onRotate }) => {
    return (
        <div className="floating-item-menu">
            <button onClick={onDelete} title="Delete" className="delete-button">
                <i className="fa-solid fa-trash text-danger fs-5"></i>
            </button>
            <button onClick={onDuplicate} title="Duplicate">
                <i className="fa-solid fa-clone fs-5"></i>
            </button>
            <button onClick={onRotate} title="Rotate">
                <i className="fa-solid fa-rotate-right fs-5"></i>
            </button>
        </div>
    );
};

export default _GridItemMenu;
